import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import type User from 'modules/core/store/models/User'

interface Props {
  user: User
}

export default function EmployeeLabel({ user }: Props) {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <UserAvatar size="s40" user={user} />
      <Box overflowX="hidden">
        <Text.Normal weight="medium" ellipsis>
          {getFullDisplayName({
            firstName: user.attributes.first_name,
            lastName: user.attributes.last_name,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}
